import { Link } from "gatsby";
import React, { useContext, useState } from "react";
import { Col, Row } from "react-grid-system";
import Button from "../button";
import { Context } from "../../redux/store";
import { useLocation } from "@reach/router";
import useMediaQuery from "../../hooks/use-media-query";

const Nav = (props) => {
  const location = useLocation();

  const isDesktop = useMediaQuery("(min-width: 992px)");

  const [subMenuOpens, setSubMenuOpens] = useState([]);

  const handleSubMenuToggle = (index) => {
    const foundIndex = subMenuOpens.indexOf(index);
    if (foundIndex >= 0) {
      subMenuOpens.splice(foundIndex, 1);
    } else {
      subMenuOpens.push(index);
    }
    setSubMenuOpens([...subMenuOpens]);
  };

  const ifCurrPage = (slug) => {
    return slug && location?.href?.includes(slug);
  };
  const { dispatch } = useContext(Context);

  const handleCloseMenu = (e) => {
    dispatch({ type: "SET_HAMBURGER_MENU", payload: false });
  };

  return (
    <div className="navbar-wrap">
      <div className="centered-content">
        <nav className="navbar">
          <Row className="row">
            <Col lg={5} className="col-left">
              <ul className="navbar-nav level-1">
                <li className="nav-item">
                  <Link
                    onClick={handleCloseMenu}
                    to="/about"
                    className={`nav-link ${
                      ifCurrPage("/about") ? "active" : ""
                    }`}
                  >
                    About
                  </Link>
                  <ul className="level-2">
                    <li>
                      <Link
                        onClick={handleCloseMenu}
                        to="/team"
                        className={`${ifCurrPage("/team") ? "active" : ""}`}
                      >
                        Team
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={handleCloseMenu}
                    to="/pipeline"
                    className={`nav-link ${
                      ifCurrPage("/pipeline") ? "active" : ""
                    }`}
                  >
                    PIPELINE
                  </Link>
                </li>
                <li className="nav-item">
                  <span className={`nav-link no-link`}>Areas of Focus</span>
                  <ul className="level-2 flex-none">
                    <li>
                      <Link
                        onClick={handleCloseMenu}
                        to="/stem-cell-mobilization-for-multiple-myeloma"
                        className={`${
                          ifCurrPage(
                            "/stem-cell-mobilization-for-multiple-myeloma"
                          )
                            ? "active"
                            : ""
                        }`}
                      >
                        Stem Cell Mobilization for Multiple Myeloma
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleCloseMenu}
                        to="/stem-cell-mobilization-for-sickle-cell-disease"
                        className={`${
                          ifCurrPage(
                            "/stem-cell-mobilization-for-sickle-cell-disease"
                          )
                            ? "active"
                            : ""
                        }`}
                      >
                        Stem Cell Mobilization for Sickle Cell Disease
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleCloseMenu}
                        to="/immunotherapy-for-pancreatic-cancer"
                        className={`${
                          ifCurrPage("/immunotherapy-for-pancreatic-cancer")
                            ? "active"
                            : ""
                        }`}
                      >
                        Immunotherapy for Pancreatic Cancer
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        onClick={handleCloseMenu}
                        to="/agi-134"
                        className={`${ifCurrPage("/agi-134") ? "active" : ""}`}
                      >
                        AGI-134
                      </Link>
                    </li> */}
                  </ul>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={handleCloseMenu}
                    to="/clinical-trials"
                    className={`nav-link ${
                      ifCurrPage("/clinical-trials") ? "active" : ""
                    }`}
                  >
                    Clinical Trials
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={handleCloseMenu}
                    to="/product"
                    className={`nav-link ${
                      ifCurrPage("/product") ? "active" : ""
                    }`}
                  >
                    PRODUCT
                  </Link>
                </li>
              </ul>
            </Col>

            <Col lg={6} className="col-right">
              <ul className="navbar-nav level-1">
                {/* <li className="nav-item">
                  <Link
                    onClick={handleCloseMenu}
                    to="/patient-and-care-partners"
                    className={`nav-link ${ifCurrPage("/patient-and-care-partners") ? "active" : ""
                      }`}
                  >
                    PATIENTS AND CARE PARTNERS
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link
                    onClick={handleCloseMenu}
                    to="/partnerships"
                    className={`nav-link ${
                      ifCurrPage("/partnerships") ? "active" : ""
                    }`}
                  >
                    PARTNERSHIPS
                  </Link>
                </li>
                <li
                  className={`nav-item ${
                    subMenuOpens.includes(0) ? "expanded" : ""
                  }`}
                >
                  <Link
                    onClick={handleCloseMenu}
                    to="https://ir.biolinerx.com"
                    className={`nav-link ${ifCurrPage("") ? "active" : ""}`}
                  >
                    INVESTORS & MEDIA
                  </Link>
                  <button
                    className={`dropdown-icon`}
                    onClick={() => handleSubMenuToggle(0)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.18"
                      height="9.973"
                      viewBox="0 0 17.18 9.973"
                    >
                      <path
                        d="M192.006,183.628a.573.573,0,0,0,0-.81l-.81-.81a.573.573,0,0,0-.81,0l-6.8,6.8-6.8-6.8a.573.573,0,0,0-.81,0l-.81.81a.573.573,0,0,0,0,.81l8.017,8.017a.572.572,0,0,0,.81,0Z"
                        transform="translate(-174.994 -181.841)"
                        fill="#fff"
                        fillRule="evenodd"
                      />
                    </svg>
                  </button>
                  {(subMenuOpens.includes(0) || isDesktop) && (
                    <ul className="level-2 md-flex">
                      <div className="first-column">
                        <li>
                          <Link
                            onClick={handleCloseMenu}
                            to="https://ir.biolinerx.com"
                            className={`${ifCurrPage("") ? "active" : ""}`}
                          >
                            Overview
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={handleCloseMenu}
                            to="https://ir.biolinerx.com/news-and-events/press-releases"
                            className={`${ifCurrPage("") ? "active" : ""}`}
                            style={{ textTransform: "none" }}
                          >
                            News and Events
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={handleCloseMenu}
                            to="https://ir.biolinerx.com/stock-information/stock-quote-and-chart"
                            className={`${ifCurrPage("") ? "active" : ""}`}
                          >
                            Stock Information
                          </Link>
                        </li>
                      </div>
                      <div className="second-column">
                        <li>
                          <Link
                            onClick={handleCloseMenu}
                            to="https://ir.biolinerx.com/corporate-governance/documents-and-charters"
                            className={`${ifCurrPage("") ? "active" : ""}`}
                          >
                            Corporate Governance
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={handleCloseMenu}
                            to="https://ir.biolinerx.com/financials/annual-reports"
                            className={`${ifCurrPage("") ? "active" : ""}`}
                          >
                            Financials
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={handleCloseMenu}
                            to="https://ir.biolinerx.com/ir-resources/email-alerts"
                            className={`${ifCurrPage("") ? "active" : ""}`}
                          >
                            IR Resources
                          </Link>
                        </li>
                      </div>
                    </ul>
                  )}
                </li>
                <li className="nav-item">
                  <Link
                    onClick={handleCloseMenu}
                    to="/careers-and-culture"
                    className={`nav-link ${
                      ifCurrPage("/careers-and-culture") ? "active" : ""
                    }`}
                  >
                    CAREERS AND CULTURE
                  </Link>
                </li>
              </ul>
              <div className="btn-wrap">
                <Button
                  className={`btn-sm ${ifCurrPage("/contact") ? "active" : ""}`}
                  to="/contact"
                  external={false}
                  onClick={handleCloseMenu}
                >
                  Contact
                </Button>
              </div>
            </Col>
          </Row>
        </nav>
      </div>
    </div>
  );
};

export default Nav;
